// First value is Make, second is model and this is year
var makeObject ={		
	"Aprilia": {
		"Caponord 1200 ABS": ["2017", "2018"],
		"Caponord 1200 ABS Rally": ["2015", "2016", "2017"],
		"Caponord 1200 ABS Travel Pack": ["2015", "2016"],
		"Dorsoduro 1200": ["2011", "2012"],
		"Dorsoduro 750": ["2010", "2011", "2012"],
		"Dorsoduro 750 ABS": ["2013", "2014", "2015", "2016", "2017", "2018"],
		"Dorsoduro 900": ["2017", "2018", "2019", "2020", "2021"],
		"ETV 1000 Caponord": ["2001", "2002", "2003", "2004", "2005", "2006", "2007"],
		"RST1000 Futura": ["2001", "2002", "2003", "2004", "2005"],
		"RSV Mille R": ["2000", "2001", "2002", "2003", "2004"],
		"RSV Mille R Haga": ["2003"],
		"RSV Mille R Nera": ["2004"],
		"RSV4 Factory APRC ABS": ["2013", "2014", "2015"],
		"RSV4 R APRC ABS": ["2013", "2014", "2015"],
		"RSV4 RF": ["2015", "2016", "2017", "2018", "2019"],
		"RSV4 RR": ["2016", "2017", "2018", "2019", "2020", "2021"],
		"SL1000 Falco": ["2000", "2001", "2002", "2003", "2004"],
		"Shiver 900": ["2017", "2018", "2019", "2020", "2021"],
		"Tuono V4 1100 Factory ABS": ["2015", "2016", "2017"],
		"Tuono V4 1100 RR ABS": ["2015", "2016", "2017"]
	},
	"BMW": {
		"F650GS ABS": ["2001", "2002", "2003", "2005"],
		"F700GS": ["2013", "2014", "2015", "2016", "2017", "2018"],
		"F800GS": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
		"F800GS Adventure": ["2014", "2015", "2016", "2017", "2018"],
		"F800GT": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"F800R": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"F800S": ["2006", "2007", "2008", "2009", "2010"],
		"F800ST": ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
		"HP2 Enduro": ["2007", "2008"],
		"HP2 Megamoto": ["2007", "2008", "2009"],
		"K1200R": ["2005", "2006", "2007", "2008"],
		"K1200R Sport": ["2007", "2008"],
		"K1200S": ["2005", "2006", "2007", "2008"],
		"K1300GT": ["2009", "2010"],
		"K1300R": ["2009", "2010", "2011", "2015", "2016"],
		"K1300S": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"K1600GT": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"K1600GTL": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2020", "2021", "2022"],
		"R nine T": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"R1200GS": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
		"R1200GS Adventure": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
		"R1200R": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"R1200RS": ["2015", "2016", "2017", "2018"],
		"R1200RT": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
		"R1200S": ["2006", "2007"],
		"R1200ST": ["2005", "2006", "2007"],
		"S1000R": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"S1000RR": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"S1000XR": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"]
	},
	"Buell": {
		"1125CR": ["2009", "2010"],
		"1125R": ["2008", "2009", "2010"],
		"Lightning CityX XB9SX": ["2005", "2006", "2007", "2008", "2009", "2010"],
		"M2 Cyclone": ["1997", "1998", "1999", "2000", "2001", "2002"],
		"S1 Lightning": ["1996", "1997", "1998"],
		"X1 Lightning": ["1999", "2000", "2001", "2002"],
		"XB12R Firebolt": ["2004", "2005", "2006", "2007", "2008", "2009", "2010"],
		"XB12S Lightning": ["2004", "2005", "2006", "2007", "2008"],
		"XB12STT Lightning": ["2007"],
		"XB12STT Lightning Super TT": ["2008"],
		"XB12Scg Lightning": ["2005", "2006", "2007", "2008", "2009", "2010"],
		"XB12Ss Lightning Long": ["2007", "2008", "2009", "2010"],
		"XB12X Ulysses": ["2006", "2007", "2008", "2009", "2010"],
		"XB12XT Ulysses": ["2008", "2009", "2010"],
		"XB9R Firebolt": ["2002", "2003", "2004", "2005", "2006", "2007"],
		"XB9S Lightning": ["2003", "2004"],
		"XB9SL": ["2004"],
		"XB9SX Lightning": ["2005", "2006", "2007", "2008", "2009", "2010"],
		"XB9SX Lightning CityX": ["2003"]
	},
	"Ducati": {
		"1098": ["2007", "2008"],
		"1098 S": ["2007", "2008"],
		"1098 S Tricolore": ["2007"],
		"1198": ["2009", "2010", "2011"],
		"1198 R Corse": ["2010", "2011"],
		"1198 S": ["2009", "2010"],
		"1198 S Corse": ["2010"],
		"1199 Panigale": ["2012", "2013", "2014"],
		"1199 Panigale S": ["2012", "2013", "2014"],
		"1199 Panigale S Tricolore": ["2012", "2013"],
		"1299 Panigale": ["2015", "2016", "2017"],
		"1299 Panigale S": ["2015", "2016", "2017"],
		"748": ["2000", "2001", "2002"],
		"749": ["2003", "2004", "2005", "2006"],
		"749R": ["2004", "2005", "2006"],
		"749S": ["2003", "2004", "2005", "2006"],
		"750": ["1999", "2000", "2001", "2002"],
		"848 EVO": ["2011", "2012", "2013"],
		"899 Panigale": ["2014", "2015"],
		"959 Panigale": ["2016", "2017", "2018", "2019"],
		"996 Biposto": ["1999", "2000", "2001"],
		"996R": ["2001"],
		"996S": ["2001", "2002", "2003"],
		"998 Biposto": ["2002", "2003"],
		"998R": ["2002"],
		"999": ["2003", "2004", "2005", "2006"],
		"999R": ["2003", "2004", "2005", "2006"],
		"999S": ["2003", "2004", "2005", "2006"],
		"Diavel": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
		"Diavel Carbon": ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
		"GT1000": ["2007", "2008", "2009", "2010"],
		"Hypermotard 1100": ["2008", "2009"],
		"Hypermotard 1100 EVO": ["2010", "2011"],
		"Hypermotard 1100 EVO SP": ["2010", "2011", "2012"],
		"Hypermotard 1100 S": ["2008", "2009"],
		"Hypermotard 796": ["2010", "2011", "2012"],
		"Hypermotard 939": ["2016", "2017", "2018"],
		"Hypermotard 939 SP": ["2016", "2017", "2018"],
		"Monster 1000": ["2004", "2005"],
		"Monster 1100": ["2009", "2010", "2011"],
		"Monster 1100 EVO": ["2012", "2013"],
		"Monster 1100 S": ["2009", "2010", "2011"],
		"Monster 1200 R": ["2016", "2017", "2018", "2019"],
		"Monster 1200 S": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"Monster 400": ["1997", "1998", "1999", "2000", "2001", "2002"],
		"Monster 600": ["1997", "1998", "1999", "2000", "2001"],
		"Monster 620": ["2002", "2003", "2004", "2005", "2006"],
		"Monster 695": ["2007", "2008"],
		"Monster 696": ["2008", "2009", "2010", "2011", "2012", "2013", "2014"],
		"Monster 750": ["1997", "1998", "1999", "2000", "2001", "2002", "2010", "2011"],
		"Monster 796": ["2011", "2012", "2013", "2014"],
		"Monster 797": ["2017", "2018", "2019", "2020", "2021"],
		"Monster 821": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"Monster 821 Dark": ["2015", "2016"],
		"Monster 821 Stripe": ["2015", "2016", "2017"],
		"Monster 900": ["1997", "1998", "1999", "2000", "2001", "2002"],
		"Monster S2R 1000": ["2006", "2007", "2008"],
		"Monster S2R 800": ["2007"],
		"Monster S4": ["2001", "2002"],
		"Monster S4R": ["2004", "2005", "2006", "2007"],
		"Monster S4Rs": ["2006"],
		"Multistrada 1000 DS": ["2005", "2006"],
		"Multistrada 1000s DS": ["2006"],
		"Multistrada 1100 S": ["2007", "2008", "2009"],
		"Multistrada 1200": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"Multistrada 1200 S": ["2010", "2011", "2015", "2016", "2017"],
		"Multistrada 1260": ["2018", "2019", "2020", "2021"],
		"Multistrada 1260 S": ["2018", "2019", "2020", "2021"],
		"Multistrada 620": ["2005", "2006"],
		"Multistrada 950": ["2017", "2018", "2019", "2020", "2021"],
		"Panigale V4": ["2018", "2019", "2020", "2021", "2022"],
		"PaulSmart 1000 LE": ["2005", "2006"],
		"SS 900": ["1998"],
		"ST2": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
		"ST3": ["2004", "2005", "2006", "2007"],
		"ST3S ABS": ["2006", "2007"],
		"ST4": ["1999", "2000", "2001", "2002", "2003", "2004"],
		"ST4S": ["2001", "2002", "2003", "2004", "2005"],
		"ST4S ABS": ["2003", "2004", "2005"],
		"Scrambler 1100": ["2018", "2019", "2020", "2021"],
		"Scrambler 1100 Special": ["2018", "2019", "2020", "2021"],
		"Scrambler 1100 Sport": ["2019", "2020", "2021"],
		"Scrambler Classic": ["2015", "2016", "2017", "2018"],
		"Scrambler Flat Track Pro": ["2016", "2017"],
		"Scrambler Full Throttle": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"Scrambler Icon": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"Scrambler Sixty2": ["2016", "2017", "2018", "2019", "2020", "2021"],
		"Scrambler Urban Enduro": ["2015", "2016", "2017"],
		"Sport 1000": ["2006"],
		"Streetfighter 848": ["2012", "2013", "2014", "2015"],
		"Streetfighter S": ["2009", "2010", "2011", "2012"],
		"Super Sport": ["2017", "2018", "2019", "2020"],
		"Super Sport S": ["2017", "2018", "2019", "2020"]
	},
	"Honda": {
		"CB1000R": ["2011", "2012", "2013", "2014", "2015", "2016", "2018", "2019"],
		"CB300F": ["2015", "2016", "2017", "2018"],
		"CB300R": ["2019"],
		"CB300R ABS": ["2019", "2020", "2021", "2022"],
		"CB350F": ["1972", "1973", "1974"],
		"CB500F": ["2013", "2014", "2015", "2016", "2017", "2018", "2019"],
		"CB500F ABS": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2021", "2022"],
		"CB500X": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"CB900F 919": ["2002", "2003", "2004", "2005", "2006", "2007"],
		"CBF1000A": ["2006", "2007", "2008", "2009", "2010"],
		"CBR1000RR SP": ["2014", "2017", "2018", "2019"],
		"CBR1100XX Super Blackbird": ["1997", "1998", "1999", "2000", "2001", "2002", "2003"],
		"CBR125R": ["2004", "2005", "2006", "2007", "2008", "2009", "2011"],
		"CBR250R ABS": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"CBR300R": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CBR500R": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"CBR600F F2": ["1991", "1992", "1993", "1994"],
		"CBR600F F3": ["1995", "1996", "1997", "1998"],
		"CBR600F F4": ["1999", "2000"],
		"CBR600F F4I": ["2001", "2002", "2003", "2004", "2005", "2006"],
		"CBR600RR": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CBR650F": ["2014", "2015", "2016", "2018"],
		"CBR900RR": ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999"],
		"CBR929RR": ["2000", "2001"],
		"CBR954RR": ["2002", "2003"],
		"CMX300 Rebel 300": ["2017", "2018", "2019", "2020", "2021", "2022"],
		"CR125M": ["1974", "1975", "1976", "1977", "1978"],
		"CR125R": ["1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
		"CR250R": ["1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
		"CR500R": ["1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001"],
		"CR80R": ["1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002"],
		"CR85R": ["2003", "2004", "2005", "2006", "2007"],
		"CRF1000L Africa Twin ABS": ["2016", "2017", "2018", "2019"],
		"CRF125F": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CRF150F": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2012", "2013", "2014", "2015", "2016", "2017"],
		"CRF150R": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CRF230F": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
		"CRF250L": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"CRF250L Rally": ["2017", "2018", "2019", "2020"],
		"CRF250R": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CRF250X": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"CRF450R": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CRF450RX": ["2017", "2018", "2019", "2020", "2021", "2022"],
		"CRF450X": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"CTX700": ["2014", "2015", "2016"],
		"Grom 125": ["2014", "2015", "2017", "2018", "2019", "2020", "2022"],
		"Grom 125 ABS": ["2018", "2019", "2020", "2022"],
		"NC700X": ["2012", "2013", "2014", "2015", "2016", "2017"],
		"ST1300": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010"],
		"ST1300 ABS": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2012"],
		"VFR1200F": ["2010", "2012", "2013"],
		"VFR800 Interceptor": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2014", "2015"],
		"VT1300CR Stateline": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"VT1300CS Sabre": ["2010", "2011", "2012", "2013", "2014"],
		"VT1300CT Interstate": ["2010", "2011", "2012", "2013", "2014", "2015"],
		"VT13CX Fury": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
		"VT750C Shadow Aero": ["2004", "2005", "2006", "2007", "2008", "2009", "2011", "2012", "2013", "2014", "2015", "2016", "2018", "2019", "2020", "2022"],
		"VT750C/CD Shadow ACE": ["1998", "1999", "2000", "2001", "2002", "2003"],
		"VTX1300C": ["2004", "2005", "2006", "2007", "2008", "2009"],
		"VTX1300R": ["2005", "2006", "2007", "2008", "2009"],
		"VTX1300S": ["2003", "2004", "2005", "2006", "2007"],
		"VTX1300T": ["2008", "2009"],
		"XR650R": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"]
	},
	"Husqvarna": {
		"701 Enduro": ["2016", "2017", "2018", "2019", "2020", "2021"],
		"701 Supermoto": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"FC250": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"FC350": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"FC450": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"FX350": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"FX450": ["2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"Nuda 900R": ["2012"],
		"Svartpilen 401": ["2018", "2019", "2020", "2021", "2022"],
		"TC125": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"TC250": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"TE125": ["2011", "2014", "2015", "2016"],
		"TE150": ["2017", "2018", "2019"],
		"TE250": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2014", "2015", "2016", "2017", "2018", "2019"],
		"TE250i": ["2018", "2019", "2020", "2021", "2022", "2023"],
		"TE300": ["2014", "2015", "2016", "2017", "2018", "2019"],
		"TE300i": ["2018", "2019", "2020", "2021", "2022", "2023"],
		"TX300": ["2017", "2018", "2019"]
	},
	"Hyosung": {
		"GT250": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"GT250R": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"GT650": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"GT650R": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"GT650S": ["2005", "2006", "2007", "2008"]
	},
	"KTM": {
		"105 SX": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011"],
		"105 XC": ["2008", "2009", "2010"],
		"1190 RC8": ["2008", "2009", "2010", "2011"],
		"1190 RC8 R": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"125 SX": ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"1290 Super Duke GT": ["2016", "2017", "2018", "2019", "2020"],
		"1290 Super Duke R": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"144 SX": ["2007", "2008"],
		"150 SX": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"150 XC": ["2010", "2011", "2012", "2013", "2014"],
		"200 EXC": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"200 MXC": ["1998", "1999", "2000", "2001", "2002", "2003"],
		"200 SX": ["1998", "1999", "2000", "2001", "2002", "2003", "2004"],
		"200 XC": ["2006", "2007", "2008", "2009"],
		"200 XC-W": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"250 SX": ["1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"250 SX-F": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"250 SXS": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
		"250 SXS-F": ["2006", "2007", "2008"],
		"250 TXC": ["1992"],
		"250 XC": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2023"],
		"250 XC-F": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"250 XCF-W": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"300 XC": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2023"],
		"300 XC-W": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2023"],
		"300 XC-W TPI Six Days": ["2019", "2020"],
		"350 EXC-F": ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"390 Duke": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"400 XC-W": ["2007", "2008", "2009", "2010", "2011"],
		"450 EXC": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
		"450 EXC-R": ["2008", "2009", "2010", "2011"],
		"450 SX-F": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"450 XC-F": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"450 XC-W": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
		"500 EXC Six Days": ["2012", "2013", "2014", "2015", "2016"],
		"505 SX-F": ["2007", "2008"],
		"505 XC-F": ["2008", "2009"],
		"525 SX": ["2003", "2004", "2005", "2006"],
		"525 XC-W": ["2007"],
		"530 EXC-R": ["2008", "2009", "2010", "2011"],
		"530 XC-W": ["2008", "2009", "2010", "2011"],
		"640 Duke II": ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006"],
		"65 SX": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"65 XC": ["2008", "2009"],
		"690 Duke": ["2008", "2009", "2010", "2011", "2013", "2014", "2015", "2016", "2017", "2018"],
		"690 Enduro R": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"85 SX (17/14)": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023"],
		"85 SX (19/16)": ["2005", "2006", "2007", "2008", "2009", "2010", "2013", "2016", "2018", "2019", "2020", "2021", "2022", "2023"],
		"990 SMT": ["2012"],
		"990 Super Duke R": ["2007", "2008", "2009", "2010", "2011"],
		"RC 390": ["2015", "2016", "2017", "2018", "2019", "2020", "2022"]
	},
	"Kawasaki": {
		"BR125 Z125 PRO": ["2017", "2018", "2019", "2020", "2021", "2022"],
		"EN650 Vulcan S": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"ER-6N": ["2009", "2010", "2015"],
		"ER650 Z650": ["2019", "2020", "2021", "2022"],
		"EX250F Ninja 250R": ["1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012"],
		"EX400 Ninja 400": ["2018", "2019", "2020", "2021", "2022"],
		"EX400 Ninja 400 ABS": ["2018", "2019", "2020", "2021", "2022"],
		"EX500 Ninja 500R": ["1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009"],
		"EX650 Ninja 650R": ["2006", "2007", "2008", "2009", "2010", "2011"],
		"KDX200": ["1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006"],
		"KDX220R": ["1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"],
		"KLE300 Versys-X 300": ["2017", "2018", "2019", "2020"],
		"KLE650 Versys ABS": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"KLR650": ["1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2022"],
		"KLX140": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"KX100": ["1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"KX112": ["2022"],
		"KX125": ["1974", "1975", "1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005"],
		"KX250": ["1974", "1975", "1976", "1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2016", "2019", "2020", "2021", "2022"],
		"KX250F": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"KX250X": ["2021", "2022"],
		"KX400": ["1975", "1976"],
		"KX420": ["1980", "1981"],
		"KX450": ["1974", "2019", "2020", "2021", "2022"],
		"KX450F": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"KX450SR": ["2022"],
		"KX450X": ["2021", "2022"],
		"KX500": ["1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004"],
		"KX60": ["1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
		"KX65": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"KX80": ["1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000"],
		"KX85": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"Z900RS": ["2018"],
		"ZG1000 Concours": ["1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006"],
		"ZR900 Z900 ABS": ["2017", "2018", "2019", "2020", "2021", "2022"],
		"ZRX1100": ["1999", "2000"],
		"ZRX1200": ["2001", "2002", "2003", "2004", "2005"],
		"ZX1000 Ninja H2 Carbon": ["2017", "2018", "2019", "2020", "2021", "2022"],
		"ZX1000 Ninja H2R": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"ZX600 Ninja 600R": ["1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997"],
		"ZX600 Ninja ZX-6": ["1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002"],
		"ZX600 Ninja ZX-6R": ["1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012"],
		"ZX600 Ninja ZX6-RR": ["2003", "2004", "2005", "2006"],
		"ZX636 Ninja ZX-6R": ["2003", "2004", "2005", "2006", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"ZX750 Ninja ZX-7": ["1989", "1990", "1991", "1992", "1993", "1994", "1995"],
		"ZX750 Ninja ZX-7R": ["1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
		"ZX750 Ninja ZX-7RR": ["1996", "1997"],
		"ZX750F Ninja 750R": ["1987", "1988", "1989", "1990"],
		"ZX900 Ninja ZX-9R": ["1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
		"ZZR 600": ["2003", "2004", "2005", "2006", "2007", "2008"],
		"ZZR1200": ["2002", "2003", "2004", "2005"]
	},
	"MV Agusta": {
		"F4 RC": ["2018", "2019"],
		"F4RR": ["2013", "2014", "2015", "2016", "2017"]
	},
	"Moto Guzzi": {
		"Audace": ["2015", "2016", "2017", "2018", "2019", "2020"],
		"Breva 1100": ["2006", "2007", "2008"],
		"Breva 1200 Sport": ["2008"],
		"Eldorado": ["2015", "2016", "2017", "2018", "2020"],
		"MGX-21": ["2018", "2020"],
		"Norge 1200": ["2007", "2008", "2009"],
		"Norge GT8V": ["2011", "2012", "2013", "2014", "2015", "2016"],
		"Stelvio 1200": ["2009", "2010", "2011", "2015"],
		"Stelvio 1200 NTX": ["2013", "2014", "2015", "2016", "2017", "2018"]
	},
	"Suzuki": {
		"DL1000 V-Strom": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2012", "2018", "2019"],
		"DL650 V-Strom": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011"],
		"DR-Z400S": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"DR-Z400SM": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"GS500": ["1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002"],
		"GS500F": ["2004", "2005", "2006", "2007", "2008", "2009"],
		"GSF1250S Bandit": ["2007", "2008", "2009"],
		"GSF400 Bandit": ["1991", "1992", "1993"],
		"GSF600S Bandit": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003"],
		"GSX-R1000": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2020", "2021", "2022"],
		"GSX-R600 GP": ["2016", "2017", "2018"],
		"GSX-R750": ["1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"GSX-S1000 ABS": ["2016", "2017", "2018", "2019", "2020", "2022"],
		"GSX-S1000FZ": ["2019"],
		"GSX-S1000Z": ["2018", "2019"],
		"GSX-S750 ABS": ["2016", "2018", "2019"],
		"GSX1100F Katana": ["1988"],
		"GSX1300BK B-King": ["2008"],
		"GSX1300R Hayabusa": ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2022"],
		"GSX250R ABS": ["2018", "2019", "2020", "2021", "2022"],
		"GSX650F": ["2008", "2009"],
		"RM125": ["1975", "1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
		"RM250": ["1976", "1977", "1978", "1979", "1980", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008"],
		"RM85": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2012", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
		"RMX450Z": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
		"RMZ250": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"RMZ450": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		"SFV650 Gladius": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2018"],
		"SV1000/S": ["2003", "2004", "2005", "2006", "2007"],
		"SV650": ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2017", "2018", "2019", "2020", "2022"],
		"SV650S": ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012"],
		"TL1000R": ["1998", "1999", "2000", "2001", "2002", "2003"],
		"TL1000S": ["1997", "1998", "1999", "2000", "2001"]
	},
	"Triumph": {
		"America LT": ["2014", "2015", "2016"]
	}
}